import { render, staticRenderFns } from "./RoleCard.vue?vue&type=template&id=3dbd4096&scoped=true"
import script from "./RoleCard.vue?vue&type=script&setup=true&lang=js"
export * from "./RoleCard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./RoleCard.vue?vue&type=style&index=0&id=3dbd4096&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbd4096",
  null
  
)

export default component.exports